import { c as _c } from "react/compiler-runtime";
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import getOptionType from './helpers/getOptionType';
import getParamForOption from './helpers/getParamForOption';
import getSelectedOptionId from './helpers/getSelectedOptionId';
import getSelectedOptionName from './helpers/getSelectedOptionName';
const UPHOLSTERY_OPTION_PATH = 'upholsteryOptionId';
const ORIENTATION_OPTION_PATH = 'hasOrientation.optionId';
const usePDPUrl = t0 => {
  const $ = _c(2);
  const {
    path
  } = t0;
  const {
    data: optionData
  } = usePDPOptions();
  let t1;
  if ($[0] !== optionData) {
    const optionTypePaths = [UPHOLSTERY_OPTION_PATH, ORIENTATION_OPTION_PATH];
    t1 = optionTypePaths.reduce((queryAcc, optionTypePath) => {
      const {
        optionTypeId,
        optionTypeName
      } = getOptionType(optionData, optionTypePath);
      const selectedOptionId = getSelectedOptionId(optionData, optionTypeId);
      const selectedOptionName = getSelectedOptionName(optionData?.options || [], optionTypeId, selectedOptionId);
      const newParam = getParamForOption(optionTypeName, selectedOptionName);
      if (queryAcc && newParam) {
        return `${queryAcc}&${newParam}`;
      }
      if (newParam) {
        return newParam;
      }
      return queryAcc;
    }, "");
    $[0] = optionData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const productUrlQuery = t1;
  if (productUrlQuery) {
    return `${path}?${productUrlQuery}`;
  }
  return path;
};
export default usePDPUrl;